const loadedMap = Object.create(null);

/**
 * 预加载图标资源
 * @param src
 */
export default function preloadImage(src) {
  if (loadedMap[src] == null) {
    loadedMap[src] = new Image();
    loadedMap[src].src = src;
  }
}
